import React, { useState, useRef, useEffect } from "react";
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import "./Signup.css";
import { Auth } from "aws-amplify";
import { API } from "aws-amplify";
import CheckBox from '../components/CheckBox';  
import Input from '../components/Input';
import { s3Upload } from "../libs/awsLib";
import config from "../config";
import Select from '../components/Select';
import { Storage } from "aws-amplify";

//  certificado_registro_files
//  renovacion_registro_files
//  carnet_regente_files 
//  autorizacion_registrante_files 

export default function Signup(props) {
  const estatusRegistroOptions = ['VIGENTE','EN PROCESO DE RENOVACION'];
  
  const file_certificado = useRef(null);
  const file_carnet = useRef(null);
  const file_autorizacion = useRef(null);
  
  //const [fields, handleFieldChange] = useFormFields({
	const [email,handleEmail] = useState(""); 
    const [password,handlePassword] = useState(""); 
    const [confirmPassword,handleConfirmPassword] = useState(""); 
    const [confirmationCode,handleConfirmationCode] = useState(""); 
	const [nombre,handleNombre] = useState(""); 
	const [telefono,handleTelefono] = useState(""); 	
	const [identidad,handleIdentidad] = useState(""); 	
	const [email_regente,handleEmailRegente] = useState(""); 
	const [relacion_establecimiento,handleRelacionEstablecimiento] = useState(""); 
	const [establecimiento,handleEstablecimiento] = useState(""); 
	const [rtn_establecimiento,handleRTNEstablecimiento] = useState(""); 	
	const [telefono_establecimiento,handleTelefonoEstablecimiento] = useState(""); 	
	const [ciudad_establecimiento,handleCiudadEstablecimiento] = useState(""); 	
	const [fax_establecimiento,handleFaxEstablecimiento] = useState(""); 
	const [whatsapp_establecimiento,handleWhatsappEstablecimiento] = useState(""); 	
	const [direccion_establecimiento,handleDireccionEstablecimiento] = useState(""); 	
	const [email_establecimiento,handleEmailEstablecimiento] = useState(""); 
	const [identidad_representante,handleIdentidadRepresentante] = useState(""); 
	const [nombre_representante,handleNombreRepresentante] = useState(""); 	
	const [nacionalidad_representante,handleNacionalidadRepresentante] = useState(""); 	
	const [telefono_representante,handleTelefonoRepresentante] = useState(""); 	
	const [nombre_regente,handleNombreRegente] = useState(""); 	
	const [identidad_regente,handleIdentidadRegente]= useState(""); 	
	const [carnet_regente,handleCarnetRegente] = useState(""); 	
	const [vencimiento_carnet_regente,handleVencimientoCarnetRegente] = useState(""); 	
	const [telefono_regente,handleTelefonoRegente] = useState(""); 
	const [numero_registro,handleNumeroRegistro] = useState(""); 
	const [fecha_registro, handleFechaRegistro] = useState(null);	
	const [fecha_caducidad, handleFechaCaducidad] = useState(null);	
	const [estatus_registro, handleEstatusRegistro] = useState("");		
	  //});
  
  // renovacion_registro_files:[],	
  // carnet_regente_files:[], 
  // certificado_registro_files:[]
  
  const [files_certificado, setFilesCertificado] = useState([]);
  const [files_carnet, setFilesCarnet] = useState([]);
  const [files_autorizacion, setFilesAutorizacion] = useState([]);
  
  const [files_borra_certificado, setFilesBorraCertificado] = useState([]);
  const [files_borra_carnet, setFilesBorraCarnet] = useState([]);
  const [files_borra_autorizacion, setFilesBorraAutorizacion] = useState([]);
  
  const [temp_files_certificado, setTempFilesCertificado] = useState([]);
  const [temp_files_carnet, setTempFilesCarnet] = useState([]);
  const [temp_files_autorizacion, setTempFilesAutorizacion] = useState([]);
  
  const [fileCertificadoURLs, setFileCertificadoURLs] = useState([]);
  const [fileRenovacionURLs, setFileRenovacionURLs] = useState([]);
  const [fileCarnetURLs, setFileCarnetURLs] = useState([]);
  const [fileAutorizacionURLs, setFileAutorizacionURLs] = useState([]);
  
  const [initialFilesCertificado,setInitialFilesCertificado] = useState([]);
  const [initialFilesAutorizacion, setInitialFilesAutorizacion] = useState([]);
  const [initialFilesCarnet, setInitialFilesCarnet] = useState([]);

  const [newUser, setNewUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAdding, setIsAdding] = useState(true);
  const [id_usuario, setId] = useState(null);
 
  useEffect(() => {
    function loadRegistro() {
      return API.get("notes", "/usuarios?email=" + props.email);
    }
 
	async function onLoad() {
 		if (props.isAuthenticated) {
			 setIsAdding(false);
		 	try {
				 const registro = await loadRegistro();
			 	 const {id, certificado_registro_files,carnet_regente_files,autorizacion_registrante_files, email,nombre,telefono,identidad,email_regente,relacion_establecimiento,establecimiento,rtn_establecimiento,telefono_establecimiento,ciudad_establecimiento,fax_establecimiento,whatsapp_establecimiento,direccion_establecimiento,email_establecimiento,identidad_representante,nombre_representante,nacionalidad_representante,telefono_representante,nombre_regente,identidad_regente,carnet_regente,vencimiento_carnet_regente,telefono_regente,numero_registro,fecha_registro,fecha_caducidad,estatus_registro} = registro.rows[0];
				 setId(id);
				 
				 setFilesCertificado(JSON.parse(certificado_registro_files));
				 setFilesCarnet(JSON.parse(carnet_regente_files));
				 setFilesAutorizacion(JSON.parse(autorizacion_registrante_files));
				 
				 if (certificado_registro_files!=null) {
					setInitialFilesCertificado(JSON.parse(certificado_registro_files));
				 	var certificadoURLs = []
					 for (const file of JSON.parse(certificado_registro_files)) {
						 const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public'})) };
						 certificadoURLs = certificadoURLs.concat(attachmentURL);
					 }
					 setFileCertificadoURLs(certificadoURLs);
				 }
				 if (carnet_regente_files !=null) {
					setInitialFilesCarnet(JSON.parse(carnet_regente_files));
				 	var carnetRegenteURLs = []
					 for (const file of JSON.parse(carnet_regente_files)) {
						 const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public'})) };
						 carnetRegenteURLs = carnetRegenteURLs.concat(attachmentURL);
					 }
					 setFileCarnetURLs(carnetRegenteURLs);
				 }
				 if (autorizacion_registrante_files !=null) {
					setInitialFilesAutorizacion(JSON.parse(autorizacion_registrante_files));
				 	var archivosAutorizacionURLs = []
					 for (const file of JSON.parse(autorizacion_registrante_files)) {
						 const attachmentURL = {file, url: (await Storage.vault.get(file,{ level: 'public'})) };
						 archivosAutorizacionURLs = archivosAutorizacionURLs.concat(attachmentURL);
					 }
					 setFileAutorizacionURLs(archivosAutorizacionURLs);
				 }	 
				 
				 handleEmail(email);
				 handleNombre(nombre);
				 handleTelefono(telefono); 
				 handleIdentidad(identidad);
				 handleEmailRegente(email_regente);
				 handleRelacionEstablecimiento(relacion_establecimiento);
				 handleEstablecimiento(establecimiento);
				 handleRTNEstablecimiento(rtn_establecimiento);
				 handleTelefonoEstablecimiento(telefono_establecimiento);
				 handleCiudadEstablecimiento(ciudad_establecimiento);
				 handleFaxEstablecimiento(fax_establecimiento)
				 handleWhatsappEstablecimiento(whatsapp_establecimiento);
				 handleDireccionEstablecimiento(direccion_establecimiento);
				 handleEmailEstablecimiento(email_establecimiento);
				 handleIdentidadRepresentante(identidad_representante);
				 handleNombreRepresentante(nombre_representante);
				 handleNacionalidadRepresentante(nacionalidad_representante);
				 handleTelefonoRepresentante(telefono_representante);
				 handleNombreRegente(nombre_regente);
				 handleIdentidadRegente(identidad_regente);
				 handleCarnetRegente(carnet_regente);
				 handleVencimientoCarnetRegente(vencimiento_carnet_regente);
				 handleTelefonoRegente(telefono_regente);
				 handleNumeroRegistro(numero_registro);
				 handleFechaRegistro(fecha_registro);
				 handleFechaCaducidad(fecha_caducidad);
				 handleEstatusRegistro(estatus_registro);
		 	} catch (e) {
				 alert(e);
		 	}
	 	}
 	}
    onLoad();
  }, [props.email]);
 
 

  function validateForm() {
	  if (!isAdding) {
	  	return true;
	  } 
    return (
      email.length > 0 &&
      password.length > 0 &&
      password === confirmPassword
    );
  }

  function validateConfirmationForm() {
    return confirmationCode.length > 0;
  }
  
  function esAutorizador() {
	  return false;
  }
  
  function validateFile(file) {
	  if (file.size > config.MAX_ATTACHMENT_SIZE) {
	      alert(
	        `Por favor elija un archivo menor a ${
	          config.MAX_ATTACHMENT_SIZE / 1000000
	        } MB.`
	      );
	      return false;
	    }
		else {
			return true;
		}
  }
  
  function addFileCertificado(file) {
	  if (validateFile(file)) {
  	  	setFilesCertificado(files_certificado.concat(file.name));
	  	setTempFilesCertificado(temp_files_certificado.concat(file));
	  }
  }
    
  function addFileCarnet(file) {
	  if (validateFile(file)) {
  	  	setFilesCarnet(files_carnet.concat(file.name));
	  	setTempFilesCarnet(temp_files_carnet.concat(file));
	  }
  }
  
  function addFileAutorizacion(file) {
	  if (validateFile(file)) {
  	  	setFilesAutorizacion(files_autorizacion.concat(file.name));
	  	setTempFilesAutorizacion(temp_files_autorizacion.concat(file));
	  }
  }
  
  function doNothingCertificado() {
  	  removeFileCertificado(files_borra_certificado);
  }
  
  function doNothingAutorizacion() {
  	  removeFileAutorizacion(files_borra_autorizacion);
  }
  
  function doNothingCarnet() {
  	  removeFileCarnet(files_borra_carnet);
  }
  
  function removeFileCertificado(borra) {
	  setFilesCertificado(files_certificado.filter(item=>item!=borra));
	  setTempFilesCertificado(temp_files_certificado.filter(item=>item.name!=borra));
	  setFileCertificadoURLs(fileCertificadoURLs.filter(item=>item.file!=borra));
  }
  
  function removeFileAutorizacion(borra) {
	  setFilesAutorizacion(files_autorizacion.filter(item=>item!=borra));
	  setTempFilesAutorizacion(temp_files_autorizacion.filter(item=>item.name!=borra));
	  setFileAutorizacionURLs(fileAutorizacionURLs.filter(item=>item.file!=borra));
  }
  
  function removeFileCarnet(borra) {
	  setFilesCarnet(files_carnet.filter(item=>item!=borra));
	  setTempFilesCarnet(temp_files_carnet.filter(item=>item.name!=borra));
	  setFileCarnetURLs(fileCarnetURLs.filter(item=>item.file!=borra));
  }
  
  
  function handleFileCertificadoChange(event) {
      file_certificado.current = event.target.files[0];
  	  addFileCertificado(file_certificado.current);
  }
	  
  function handleFileAutorizacionChange(event) {
	  file_autorizacion.current = event.target.files[0];
	  addFileAutorizacion(file_autorizacion.current);
   }
   
   function handleFileCarnetChange(event) {
      file_carnet.current = event.target.files[0];
   	  addFileCarnet(file_carnet.current);
   }
	
	
    function renderFiles(files) {
	   
 		 return [].concat(files).map((file, i) =>
          (            
            <FormGroup>
             <FormControl.Static>
               <a
                 target="_blank"
                 rel="noopener noreferrer"
                 href={file.url}
               >
                 {file.file}
               </a>
             </FormControl.Static>
           </FormGroup>
          ) 
        );
      }
	  
  
	  function validacionesFinales() {
		 
		  if (email.length<10) {
		  	 alert('Debe ingresar un email valido')
			  return false;
		  }
		  
		  if (password != confirmPassword) {
		  	 alert('Password y confirmacion no coinciden')
			  return false;
		  }
		  
		  if (nombre.length==0) {
			  alert('Debe proporcionar un nombre');
			  return false;
		  }
		  
		  if (!(email=="henry_jrd@yahoo.com" || email=="tmcesar95@hotmail.com" || email.includes("senasa.gob.hn") || email.includes("ssvhonduras.org") || email.includes("oirsa") || email.includes("mentors.com"))) {
		  	  if (estatus_registro.length==0) {
				  alert('Debe proporcionar un estatus del registro');
				  return false;
		  	  }
			  if (nombre_representante.length==0) {
			  	  alert('Debe proporcionar el nombre del representante');
				  return false;
			  }
			  if (identidad_representante.length==0) {
				  alert('Debe proporcionar una identidad del representante');
				  return false;
			  }
			  if (telefono_representante.length==0) {
			  	  alert('Debe proporcionar un telefono del representante');
				  return false;
			  }
			  if (nacionalidad_representante.length==0) {
			  	  alert('Debe proporcionar una nacionalidad del representante');
				  return false;
			  }
			  if (nombre_regente.length==0) {
			  	  alert('Debe proporcionar el nombre del regente');
				  return false;
			  }
			  if (identidad_regente.length==0) {
			  	  alert('Debe proporcionar la identidad del regente');
				  return false
			  }
			  if (carnet_regente.length==0) {
			  	  alert('Debe proporcionar el # de carnet del regente');
				  return false;
			  }
			  if (establecimiento.length==0) {
			  	  alert('Debe proporcionar el nombre del establecimiento');
				  return false;
			  }
			  if (ciudad_establecimiento.length==0) {
			  	  alert('Debe proporcionar la ciudad del establecimiento');
				  return false;
			  }
			  if (direccion_establecimiento.length==0) {
			  	  alert('Debe proporcionar la direccion del establecimiento');
				  return false;
			  }
			  if (numero_registro.length==0) {
			  	  alert('Debe proporcionar un numero de registro');
				  return false;
			  }
			  if (files_certificado.length==0) {
			  	  alert('Debe adjuntar al menos un archivo del Certificado');
				  return false;
			  }
			  if (files_carnet.length==0) {
			  	  alert('Debe adjuntar al menos un archivo de la copia del Carnet del regente');
				  return false;
			  }
			  if (files_autorizacion.length==0) {
			  	  alert('Debe adjuntar al menos un archivo de la copia de la autorizacion');
				  return false;
			  }
			  if (email_regente==null || email_regente.length==0) {
			  	  alert('Debe especificar el correo electrónico del regente');
				  return false;
			  }
			  
		  }	
		  return true;
	  }
	  
 	 function getCommon(arr1, arr2) {
 	   var common = [];                   
 	   for(var i=0 ; i<arr1.length ; ++i) {
 	     for(var j=0 ; j<arr2.length ; ++j) {
 	       if(arr1[i] == arr2[j]) {       
 	         common.push(arr1[i]);       
 	       }
 	     }
 	   }
  
 	   return common;                    
 	 }

  async function handleSubmit(event) {
    event.preventDefault();
	
	
    if (!validacionesFinales()) {
    	return;
    }
	
    setIsLoading(true);
	
  		
    try {
		if (isAdding) {
      	  const newUser = await Auth.signUp({
        	  username: email,
        	  password: password
      		});
      	  setIsLoading(false);
      	  setNewUser(newUser);
	  } else {
      	var attachmentsCertificado = getCommon(initialFilesCertificado,files_certificado);
      	for (const file of temp_files_certificado) {
        	  const attachment = await s3Upload(file);
      		  attachmentsCertificado = attachmentsCertificado.concat(attachment);
      	  }
    	  var certificado = JSON.stringify(attachmentsCertificado);
  
    	  var attachmentsAutorizacion = getCommon(initialFilesAutorizacion,files_autorizacion);
     	 for (const file of temp_files_autorizacion) {
     		 const attachment = await s3Upload(file);
     		 attachmentsAutorizacion = attachmentsAutorizacion.concat(attachment);
     	   }
     	  var autorizaciones = JSON.stringify(attachmentsAutorizacion);
  
		  var attachmentsCarnet = getCommon(initialFilesCarnet,files_carnet);
    	  for (const file of temp_files_carnet) {
    		  const attachment = await s3Upload(file);
       	  	  attachmentsCarnet = attachmentsCarnet.concat(attachment);
     	   }
     	  var carnet = JSON.stringify(attachmentsCarnet);
		  
	  	  createUsuario(certificado,autorizaciones,carnet,email,nombre,telefono,identidad,relacion_establecimiento,establecimiento,rtn_establecimiento,telefono_establecimiento,ciudad_establecimiento,fax_establecimiento,whatsapp_establecimiento,direccion_establecimiento,email_establecimiento,identidad_representante,nombre_representante,nacionalidad_representante,telefono_representante,nombre_regente,identidad_regente,carnet_regente,vencimiento_carnet_regente,telefono_regente,numero_registro,fecha_registro,fecha_caducidad,estatus_registro,email_regente); 
          setIsLoading(false);
		  props.history.push("/");
	  }
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }

  async function handleConfirmationSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {

      await Auth.confirmSignUp(email, confirmationCode);
      await Auth.signIn(email, password);
	  
    	var attachmentsCertificado = []; //(!isAdding)?getCommon(initialFilesFactura,files_factura):[];
    	for (const file of temp_files_certificado) {
      	  const attachment = await s3Upload(file);
    		  attachmentsCertificado = attachmentsCertificado.concat(attachment);
    	  }
  	  var certificado = JSON.stringify(attachmentsCertificado);
  
  	  var attachmentsAutorizacion = []; //(!isAdding)?getCommon(initialFilesAutorizacion,files_autorizacion):[];
   	 for (const file of temp_files_autorizacion) {
   		 const attachment = await s3Upload(file);
   		 attachmentsAutorizacion = attachmentsAutorizacion.concat(attachment);
   	   }
   	  var autorizaciones = JSON.stringify(attachmentsAutorizacion);
  
   	 var attachmentsCarnet = []; //(!isAdding)?getCommon(initialFilesTGR,files_tgr):[];
  	  for (const file of temp_files_carnet) {
  		  const attachment = await s3Upload(file);
     	  attachmentsCarnet = attachmentsCarnet.concat(attachment);
   	   }
   	  var carnet = JSON.stringify(attachmentsCarnet);
  	  createUsuario(certificado,autorizaciones,carnet,email,nombre,telefono,identidad,relacion_establecimiento,establecimiento,rtn_establecimiento,telefono_establecimiento,ciudad_establecimiento,fax_establecimiento,whatsapp_establecimiento,direccion_establecimiento,email_establecimiento,identidad_representante,nombre_representante,nacionalidad_representante,telefono_representante,nombre_regente,identidad_regente,carnet_regente,vencimiento_carnet_regente,telefono_regente,numero_registro,fecha_registro,fecha_caducidad,estatus_registro,email_regente); 
      props.userHasAuthenticated(true);
	  await Auth.signOut();
	  props.userHasAuthenticated(false);
	  props.history.push("/login");
	  
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }
  
  function createUsuario(certificado,autorizaciones,carnet,email,nombre,telefono,identidad,relacion_establecimiento,establecimiento,rtn_establecimiento,telefono_establecimiento,ciudad_establecimiento,fax_establecimiento,whatsapp_establecimiento,direccion_establecimiento,email_establecimiento,identidad_representante,nombre_representante,nacionalidad_representante,telefono_representante,nombre_regente,identidad_regente,carnet_regente,vencimiento_carnet_regente,telefono_regente,numero_registro,fecha_registro,fecha_caducidad,estatus_registro,email_regente) {
	  if (isAdding) {
	return API.post("notes", "/usuarios", {
		body: {certificado_registro_files:certificado, carnet_regente_files: carnet, autorizacion_registrante_files: autorizaciones,email,nombre,telefono,identidad,relacion_establecimiento,establecimiento,rtn_establecimiento,telefono_establecimiento,ciudad_establecimiento,fax_establecimiento,	whatsapp_establecimiento,	direccion_establecimiento,	email_establecimiento,identidad_representante,nombre_representante,nacionalidad_representante,telefono_representante,nombre_regente,identidad_regente,carnet_regente,vencimiento_carnet_regente,telefono_regente,numero_registro,fecha_registro,fecha_caducidad,estatus_registro,email_regente}
    });
	  } else {
	  	return API.put("notes", "/usuarios/" + id_usuario, {
	  		body: {certificado_registro_files:certificado, carnet_regente_files: carnet, autorizacion_registrante_files: autorizaciones,nombre,telefono,identidad,relacion_establecimiento,establecimiento,rtn_establecimiento,telefono_establecimiento,ciudad_establecimiento,fax_establecimiento,	whatsapp_establecimiento,	direccion_establecimiento,	email_establecimiento,identidad_representante,nombre_representante,nacionalidad_representante,telefono_representante,nombre_regente,identidad_regente,carnet_regente,vencimiento_carnet_regente,telefono_regente,numero_registro,fecha_registro,fecha_caducidad,estatus_registro,email_regente}
	      });
	  } 
  }
  
  function adjuntos() {
  	return (
	  (email=="" || email=="tmcesar95@hotmail.com" || email.includes("senasa.gob.hn") || email.includes("ssvhonduras.org") || email.includes("mentors.com") || email.includes("oirsa") || email=="henry_jrd@yahoo.com") 
	        ? (null)
  		: (
	<div>
		<FormGroup controlId="file_certificado">
	   	  <ControlLabel>ADJUNTE AQUI: Certificado de Registro de Establecimiento Importador Vigente (si se encuentra en proceso de renovación adjuntar copia de tracking)</ControlLabel>
	         <div>
	   		 {renderFiles(fileCertificadoURLs)}
	     	  </div>
	   	     <div> 
	   		  <div>
	                <FormControl onChange={handleFileCertificadoChange} type="file"/>
	                <CheckBox  title=''
	                  name={'files_certificado_borrar'}
	                  options={files_certificado}
	                  selectedOptions = {files_borra_certificado}
	   		    type="radio"
	                  handleChange={e=>setFilesBorraCertificado(e.target.value)}/>
	                <LoaderButton
	                  block
	                  bsSize="small"
	                  bsStyle="danger"
	                  onClick={doNothingCertificado}
	   		    disabled={files_certificado.length==0}>
	   		    SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ
	                </LoaderButton>
	   		  </div>
	   	  </div>
	   </FormGroup>
	   <FormGroup controlId="file_autorizacion">
			<ControlLabel>ADJUNTE AQUI: Autorización de Registrante (en caso que el importador no sea el propietario del registro)</ControlLabel>
			 	     <div>
			 	   	 {renderFiles(fileAutorizacionURLs)}
			 	      </div>
			 	     <div> 
			 	   	  <div>
			 	               <FormControl onChange={handleFileAutorizacionChange} type="file"/>
			 	               <CheckBox  title=''
			 	                 name={'files_autorizacion_borrar'}
			 	                 options={files_autorizacion}
			 	                 selectedOptions = {files_borra_autorizacion}
			 	   	    type="radio"
			 	                 handleChange={e=>setFilesBorraAutorizacion(e.target.value)}/>
			 	               <LoaderButton
			 	                 block
			 	                 bsSize="small"
			 	                 bsStyle="danger"
			 	                 onClick={doNothingAutorizacion}
			 	   	    disabled={files_autorizacion.length==0}>
			 	   	    SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ
			 	               </LoaderButton>
			 	   	  </div>
			 	     </div>
			 	    </FormGroup> 	

			     <FormGroup controlId="file_carnet">
			 	   	  <ControlLabel>ADJUNTE AQUI: Carnet(s) de Regente(s) Vigente(s) (o constancia del colegio profesional al que pertenece)</ControlLabel>
			 	         <div>
			 	   		 {renderFiles(fileCarnetURLs)}
			 	     	  </div>
			 	   	  <div> 
			 	   		  <div>
			 	                <FormControl onChange={handleFileCarnetChange} type="file"/>
			 	                <CheckBox  title=''
			 	                  name={'files_carnet_borrar'}
			 	                  options={files_carnet}
			 	                  selectedOptions = {files_borra_carnet}
			 	   		    type="radio"
			 	                  handleChange={e=>setFilesBorraCarnet(e.target.value)}/>
			 	                <LoaderButton
			 	                  block
			 	                  bsSize="small"
			 	                  bsStyle="danger"
			 	                  onClick={doNothingCarnet}
			 	   		    disabled={files_carnet.length==0}>
							SI DESEA ELIMINAR ALGUNO DE LOS ARCHIVOS ADJUNTOS, SELECCIONE EL ARCHIVO Y LUEGO OPRIMA AQUÍ	  
			 	                </LoaderButton>
			 	   		  </div>
			 	   	  </div>
			   </FormGroup> 	

	</div>
  		)
  	);
  }
  
  function additionalFields() {
	  return (
	  (email=="" || email=="tmcesar95@hotmail.com" || email.includes(".gob.hn") || email.includes("ssvhonduras.org") || email.includes("mentors.com") || email.includes("oirsa") || email=="henry_jrd@yahoo.com") 
	        ? (null)
			: (
		<div>	
        <FormGroup controlId="relacion_establecimiento" bsSize="large">
          <ControlLabel>Relación con el Establecimiento</ControlLabel>
          <FormControl
            type="relacion_establecimiento"
            value={relacion_establecimiento}
            onChange={e=>handleRelacionEstablecimiento(e.target.value)}
          />
        </FormGroup>
  <div className="div-uno">
		<ControlLabel>2. DATOS DEL ESTABLECIMIENTO</ControlLabel>
        <FormGroup controlId="establecimiento" bsSize="large">
          <ControlLabel>Nombre del Establecimiento</ControlLabel>
          <FormControl
            type="establecimiento"
            value={establecimiento}
            onChange={e=>handleEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="rtn_establecimiento" bsSize="large">
          <ControlLabel>RTN</ControlLabel>
          <FormControl
            type="rtn_establecimiento"
            value={rtn_establecimiento}
            onChange={e=>handleRTNEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="telefono_establecimiento" bsSize="large">
          <ControlLabel>Teléfono</ControlLabel>
          <FormControl
            type="telefono_establecimiento"
            value={telefono_establecimiento}
            onChange={e=>handleTelefonoEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="ciudad_establecimiento" bsSize="large">
          <ControlLabel>Ciudad</ControlLabel>
          <FormControl
            type="ciudad_establecimiento"
            value={ciudad_establecimiento}
            onChange={e=>handleCiudadEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="fax_establecimiento" bsSize="large">
          <ControlLabel>Fax</ControlLabel>
          <FormControl
            type="fax_establecimiento"
            value={fax_establecimiento}
            onChange={e=>handleFaxEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="whatsapp_establecimiento" bsSize="large">
          <ControlLabel>Whatsapp</ControlLabel>
          <FormControl
            type="whatsapp_establecimiento"
            value={whatsapp_establecimiento}
            onChange={e=>handleWhatsappEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="direccion_establecimiento" bsSize="large">
          <ControlLabel>Dirección</ControlLabel>
          <FormControl
            type="direccion_establecimiento"
            value={direccion_establecimiento}
            onChange={e=>handleDireccionEstablecimiento(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="email_establecimiento" bsSize="large">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            type="email_establecimiento"
            value={email_establecimiento}
            onChange={e=>handleEmailEstablecimiento(e.target.value)}
          />
        </FormGroup>
	</div>
	<div className="div-dos">
		<ControlLabel>3. DATOS DEL REPRESENTANTE LEGAL Y REGENTE</ControlLabel>
        <FormGroup controlId="identidad_representante" bsSize="large">
          <ControlLabel>* N° Identidad del Representante Legal</ControlLabel>
          <FormControl
            type="identidad_representante"
            value={identidad_representante}
            onChange={e=>handleIdentidadRepresentante(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="nombre_representante" bsSize="large">
          <ControlLabel>Nombres y Apellidos Representante Legal</ControlLabel>
          <FormControl
            type="nombre_representante"
            value={nombre_representante}
            onChange={e=>handleNombreRepresentante(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="nacionalidad_representante" bsSize="large">
          <ControlLabel>Nacionalidad</ControlLabel>
          <FormControl
            type="nacionalidad_representante"
            value={nacionalidad_representante}
            onChange={e=>handleNacionalidadRepresentante(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="telefono_representante" bsSize="large">
          <ControlLabel>Teléfono de Representante Legal</ControlLabel>
          <FormControl
            type="telefono_representante"
            value={telefono_representante}
            onChange={e=>handleTelefonoRepresentante(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="nombre_regente" bsSize="large">
          <ControlLabel>* Nombres y Apellidos del Regente</ControlLabel>
          <FormControl
            type="nombre_regente"
            value={nombre_regente}
            onChange={e=>handleNombreRegente(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="identidad_regente" bsSize="large">
          <ControlLabel>N° Identidad del Regente</ControlLabel>
          <FormControl
            type="identidad_regente"
            value={identidad_regente}
            onChange={e=>handleIdentidadRegente(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="carnet_regente" bsSize="large">
          <ControlLabel>N° de Carnet de Regencia</ControlLabel>
          <FormControl
            type="carnet_regente"
            value={carnet_regente}
            onChange={e=>handleCarnetRegente(e.target.value)}
          />
        </FormGroup>
            <Input inputType={'date'} 
             name={'vencimiento_carnet_regente'}
             title= {'Fecha de Vencimiento del Carnet de Regente'} 
             value={vencimiento_carnet_regente} 
             handleChange={e=>handleVencimientoCarnetRegente(e.target.value)} />
			 
        <FormGroup controlId="telefono_regente" bsSize="large">
          <ControlLabel>Teléfono Regente</ControlLabel>
          <FormControl
            type="telefono_carnet_regente"
            value={telefono_regente}
            onChange={e=>handleTelefonoRegente(e.target.value)}
          />
        </FormGroup>
			
        <FormGroup controlId="email_regente" bsSize="large">
          <ControlLabel>Email del Regente</ControlLabel>
          <FormControl
            type="email_regente"
            value={email_regente}
            onChange={e=>handleEmailRegente(e.target.value)}
          />
        </FormGroup>
  </div>
  <div className="div-tres">
		<ControlLabel>4. ESTATUS DEL REGISTRO DE ESTABLECIMIENTO IMPORTADOR</ControlLabel>
        <FormGroup controlId="numero_registro" bsSize="large">
          <ControlLabel>Nro. Registro de Establecimiento Importador</ControlLabel>
          <FormControl
            type="numero_registro"
            value={numero_registro}
            onChange={e=>handleNumeroRegistro(e.target.value)}
          />
        </FormGroup>
			
            <Input inputType={'date'} 
             name={'fecha_registro'}
             title= {'Fecha expedición del Registro'} 
             value={fecha_registro} 
             handleChange={e=>handleFechaRegistro(e.target.value)} />
			 
			 <FormGroup controlId="fecha_caducidad_registro" bsSize="large">
			   <ControlLabel>Fecha de caducidad del Registro</ControlLabel>
               <FormControl type="date"
                 value={fecha_caducidad}
                 onChange={e=>handleFechaCaducidad(e.target.value)} />
			 </FormGroup>
					
			 <Select title={'Estatus del Registro de Importador'}
			   	   		name={'estatus_registro'}
			   	  	        options = {estatusRegistroOptions} 
			   	  	        value = {estatus_registro}
			   	     		placeholder={'Seleccione...'}
							
			   	            handleChange = {e=>handleEstatusRegistro(e.target.value)}
			   	       /> 
			
		</div>
   	</div>				
							
				)
		);

  }
  
  async function handleRegresar(event) {
	  props.history.push("/");
  }

  function renderConfirmationForm() {
    return (
      <form onSubmit={handleConfirmationSubmit}>
        <FormGroup controlId="confirmationCode" bsSize="large">
          <ControlLabel>Código de confirmación</ControlLabel>
          <FormControl
            autoFocus
            type="tel"
            onChange={e=>handleConfirmationCode(e.target.value)}
            value={confirmationCode}
          />
          <HelpBlock>Por favor revise su email para obtener el código de verificación</HelpBlock>
        </FormGroup>
        <LoaderButton
          block
          type="submit"
          bsSize="large"
          isLoading={isLoading}
          disabled={!validateConfirmationForm()}
        >
          Verify
        </LoaderButton>
      </form>
    );
  }

  function renderForm() {
    return (
      <form>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email del solicitante</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={email}
			disabled={!isAdding}
            onChange={e=>handleEmail(e.target.value)}
          />
        </FormGroup>
		<ControlLabel>1. DATOS DEL SOLICITANTE</ControlLabel>
        <FormGroup controlId="nombre" bsSize="large">
          <ControlLabel>Nombres y Apellidos</ControlLabel>
          <FormControl
            type="nombre"
            value={nombre}
            onChange={e=>handleNombre(e.target.value)}
          />
        </FormGroup>	
        <FormGroup controlId="telefono" bsSize="large">
          <ControlLabel>Teléfono</ControlLabel>
          <FormControl
            type="telefono"
            value={telefono}
            onChange={e=>handleTelefono(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="identidad" bsSize="large">
          <ControlLabel>N° Identidad del Solicitante</ControlLabel>
          <FormControl
            type="identidad"
            value={identidad}
            onChange={e=>handleIdentidad(e.target.value)}
          />
        </FormGroup>
		<div>
			{additionalFields()}
			{adjuntos()}
		</div>		
	{
		(isAdding) && (
	  <div>
        <FormGroup controlId="password" bsSize="large">
          <ControlLabel>Password del Solicitante (mínimo 8 caracteres y debe colocar al menos una letra minúscula, una mayúscula y un símbolo*-/+)</ControlLabel>
          <FormControl
            type="password"
            value={password}
            onChange={e=>handlePassword(e.target.value)}
          />
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <ControlLabel>Confirmación del Password del Solicitante</ControlLabel>
          <FormControl
            type="password"
            onChange={e=>handleConfirmPassword(e.target.value)}
            value={confirmPassword}
          />
        </FormGroup>
	  </div>
		) 
	}
        <LoaderButton
          block
          type="submit"
          bsSize="large"
	      bsStyle="primary"
          isLoading={isLoading}
		  onClick={handleSubmit}
          disabled={!validateForm()}
        >
          {isAdding?"Registrarse":"Presione para guardar los cambios de su registro"}
        </LoaderButton>
    { (!isAdding) && 
		(
		<LoaderButton
        block
        bsSize="large"
        bsStyle="danger"
		onClick={handleRegresar}
        isLoading={isLoading}
        disabled={!validateForm()}
      >
        Regresar
      </LoaderButton>
	   )	
    }
      </form>
    );
  }

  return (
    <div>
      {newUser === null ? renderForm() : renderConfirmationForm()}
    </div>
  );
}
